$(document).ready(function(e){

	if ($(document).find('.field.delayed-execution-date')){
		$(document).find('.field.delayed-execution-date').each(function(){

            var dom = $(this);
            var minYear = new Date().getFullYear()
            var maxYear = new Date().getFullYear()+3;

			// initiate and configure date dropdowns plugin
			// https://www.jqueryscript.net/time-clock/Easy-Customizable-jQuery-Dropdown-Date-Picker-Plugin.html
			var input = dom.find('input').dateDropdowns({
				defaultDateFormat: "dd/mm/yy",
				submitFormat: "dd/mm/yyyy",
				monthFormat: "short",
				daySuffixes: false,
				minYear: minYear,
				maxYear: maxYear,
                minAge: 0
			});	
            
            var earlier_than_today_msg = "Date must be in the future.";

			PopulateDropdownsOnLoad(input,dom);

            var ded_field = dom.find('input[name="DelayedExecutionDate"].delayed-execution-date');
			if (ded_field.length > 0){
				ded_field.rules(
					"add", {
						earlierThanToday: true,
						messages: {						
							earlierThanToday: earlier_than_today_msg
						}
					}
				);
			}

            input.change(function(){
				var dateText = $(this).val();
				if(dateText != null || dateText != ''){
					
					if(AllDropdownsFull(dom)){
						// resolve issue of date only applying to year, not day/month
						// see: https://github.com/IckleChris/jquery-date-dropdowns/issues/23
						if(AfterToday(dateText)){
							if($('#' + $(this).attr("id") + '-error').length){
								$('#' + $(this).attr("id") + '-error').html(earlier_than_today_msg);
							} else {
                                $('#' + $(this).attr("id") + '-error').remove();
								$("<div/>")
									.attr('id',$(this).attr("id") + '-error')
									.attr('class','error')
									.html(earlier_than_today_msg)
									.appendTo($(this).parents('.field')); 
							}
							dom.find('.day, .month, .year').removeClass('valid').addClass('invalid error').attr('aria-invalid',true);
						}else {
							dom.find('.day, .month, .year').removeClass('invalid error').addClass('valid').attr('aria-invalid',false);
							$('#' + $(this).attr("id") + '-error').remove();

						}
					}
				}
			});

		});

        function AfterToday(dateText){
			var atLeastTomorrow = false;
			var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

			// Convert human-friendly dd/mm/yyyy to js-friendly mm/dd/yyyy
			var inputDate_parts = dateText.split("/");
			var inputDate = new Date(inputDate_parts[2], inputDate_parts[1]-1, inputDate_parts[0]); // month is 0-based

			if (inputDate < tomorrow){
				atLeastTomorrow = true;
			}
			return atLeastTomorrow;
		}

		function AllDropdownsFull(wrapper){
			var dropdowns = wrapper.find('select');
			var complete = true;
			dropdowns.each(function(){
				if(!$(this).val()){
					complete = false;
				}
			});
			if(complete){
				return true;
			}
		}

		function PopulateDropdownsOnLoad(input,wrapper){
			if(input.val()){
				var inputDate_parts = input.val().split("/");
				var dropdowns = wrapper.find('select');
				dropdowns.each(function(){
					if($(this).is('.day')){
						$(this).val(inputDate_parts[0]);
					}
					if($(this).is('.month')){
						$(this).val(inputDate_parts[1]);
					}
					if($(this).is('.year')){
						$(this).val(inputDate_parts[2]);
					}
				});
			}
		}

	}
	
});